/**
 * @Description 客流画像第二页
 */

import { FC } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import NormalProgress from '../NormalProgress';
import PPTBarChart from '../BarChart';

const PassengerFlowPortraitTwo:FC<any> = ({
  rangeName,
  workdayAndHolidayInfoVO
}) => {
  return (
    <div className={styles['page']}>
      <Header title={`客流画像 — ${rangeName}`}/>

      <div className={styles['content']}>

        <div className={styles['left']}>
          <div className={styles['left-top']}>
            <PPTBarChart
              width={663}
              height={474}
              title='年龄分布'
              xAxisData={workdayAndHolidayInfoVO?.age?.workday?.map((item) => item.name) || []}
              direction='horizontal'
              percent
              seriesData={[{
                name: '工作日',
                data: workdayAndHolidayInfoVO?.age?.workday?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#8B3DFF',
                  borderRadius: [0, 100, 100, 0]
                },
                barWidth: 20,
              },
              {
                name: '节假日',
                data: workdayAndHolidayInfoVO?.age?.holiday?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#00D7FF',
                  borderRadius: [0, 100, 100, 0]
                },
                barWidth: 20,
              }]}
              config={{
                yAxis: {
                  show: false
                },
                xAxis: {
                  axisLabel: {
                    color: '#999999',
                    lineHeight: 22,
                    fontSize: 16,
                    fontWeight: 400,
                    width: 74,
                    align: 'right',
                    overflow: 'truncate',
                  },
                },
                title: {
                  top: 16,
                  left: 24,
                  textStyle: {
                    color: '#222222',
                    fontWeight: 500,
                    fontSize: 24,
                    lineHeight: 33,
                  },
                },
                grid: {
                  top: 68,
                  left: 104,
                  bottom: 33,
                  right: 40
                },
                legend: {
                  top: 22,
                  left: 473,
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 24,
                  textStyle: {
                    fontSize: 16,
                    lineHeight: 22,
                    color: '#222222'
                  }
                }
              }}
            />
          </div>
        </div>

        <div className={styles['right']}>

          {/* <div className={styles['right-top']}>
            <PPTBarChart
              width={663}
              height={270}
              title='客流子女年龄情况'
              xAxisData={workdayAndHolidayInfoVO?.childrenAge?.workday?.map((item) => item.name) || []}
              showLabel={false}
              percent
              seriesData={[{
                name: '工作日',
                data: workdayAndHolidayInfoVO?.childrenAge?.workday?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#FE7E7E',
                  borderRadius: [100, 100, 0, 0]
                },
                barWidth: 20,
              },
              {
                name: '节假日',
                data: workdayAndHolidayInfoVO?.childrenAge?.holiday?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#259DB2',
                  borderRadius: [100, 100, 0, 0]
                },
                barWidth: 20,
              }]}
              config={{
                title: {
                  top: 20,
                  left: 27,
                  textStyle: {
                    color: '#222222',
                    fontWeight: 500,
                    fontSize: 24,
                    lineHeight: 33,
                  },
                },
                grid: {
                  top: 74,
                  left: 65,
                  bottom: 50,
                  right: 19
                },
                legend: {
                  top: 26,
                  left: 431,
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 24,
                  textStyle: {
                    fontSize: 16,
                    lineHeight: 22,
                    color: '#222222'
                  }
                }
              }}
            />
          </div> */}

          <div className={styles['right-bottom']}>
            <PPTBarChart
              width={663}
              height={474}
              title='客流所在行业分布'
              xAxisData={workdayAndHolidayInfoVO?.industry?.workday?.slice(0, 6)?.map((item) => item.name) || []}
              direction='horizontal'
              percent
              seriesData={[{
                name: '工作日',
                data: workdayAndHolidayInfoVO?.industry?.workday?.slice(0, 6)?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#8B3DFF',
                  borderRadius: [0, 100, 100, 0]
                },
                barWidth: 20,
              },
              {
                name: '节假日',
                data: workdayAndHolidayInfoVO?.industry?.holiday?.slice(0, 8)?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#00D7FF',
                  borderRadius: [0, 100, 100, 0]
                },
                barWidth: 20,
              }]}
              config={{
                yAxis: {
                  show: false
                },
                xAxis: {
                  axisLabel: {
                    color: '#999999',
                    lineHeight: 22,
                    fontSize: 16,
                    fontWeight: 400,
                    width: 74,
                    align: 'right',
                    overflow: 'truncate',
                  },
                },
                title: {
                  top: 16,
                  left: 24,
                  textStyle: {
                    color: '#222222',
                    fontWeight: 500,
                    fontSize: 24,
                    lineHeight: 33,
                  },
                },
                grid: {
                  top: 68,
                  left: 104,
                  bottom: 33,
                  right: 44
                },
                legend: {
                  top: 22,
                  left: 473,
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 24,
                  textStyle: {
                    fontSize: 16,
                    lineHeight: 22,
                    color: '#222222'
                  }
                }
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles['bottom']}>
        <div className={styles['car']}>
          <div className={styles['title']}>车辆情况(有车)</div>

          <div className={styles['box']}>
            <NormalProgress title='节假日' value={(workdayAndHolidayInfoVO?.car?.holiday[0]?.value * 100).toFixed(2) || 0} theme='blue' className={styles['box-weekend']}/>
            <NormalProgress title='工作日' value={(workdayAndHolidayInfoVO?.car?.workday[0]?.value * 100).toFixed(2) || 0} theme='blue'/>
          </div>

        </div>

        <div className={styles['marriage']}>
          <div className={styles['title']}>婚姻状况(已婚)</div>

          <div className={styles['box']}>
            <NormalProgress title='节假日' value={(workdayAndHolidayInfoVO?.married?.holiday[0]?.value * 100).toFixed(2) || 0} theme='red' className={styles['box-weekend']}/>
            <NormalProgress title='工作日' value={(workdayAndHolidayInfoVO?.married?.workday[0]?.value * 100).toFixed(2) || 0} theme='red'/>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PassengerFlowPortraitTwo;
